import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * ACNE forms
   */
  {
    // 1
    label: 'What are you looking to tackle?',
    subLabel: '(Select at least one, or all that apply.)',
    field: 'acneTackle',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Acne can present in many ways. Knowing your exact type helps our doctors determine what treatment is needed.',
        lineBreak: true
      },
      {
        title: 'What are all these?',
        info: '',
        lineBreak: true
      },
      {
        title: 'Whiteheads',
        info: 'Whiteheads are plugged pores that are under the skin’s surface. They look like small white dots.'
      },
      {
        title: 'Blackheads',
        info: 'Blackheads are plugged pores that are open on the skin’s surface. They look like small, dark dots.'
      },

      {
        title: 'Papules',
        info: 'Papules are small, tender red or pink bumps. They are often referred to as pimples.'
      },
      {
        title: 'Pustules',
        info: 'Pustules are papules with pus on top. They are often referred to as pimples.'
      },
      {
        title: 'Cysts',
        info: 'Cysts is a hollow that has formed under the skin, and filled with either air, pus, or fluid of some kind.'
      },
      {
        title: 'Boils',
        info: 'Boils are painful, pus-filled bumps that form under the skin when bacteria infects or inflames a hair follicle.'
      },
      {
        title: 'Nodules',
        info: 'Nodules are large, painful lumps deep under the skin’s surface. They’re abnormal tissue growths, and can be red or dark-hued.'
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'whiteheads', value: 'Whiteheads' },
        { key: 'blackheads', value: 'Blackheads' },
        { key: 'papules', value: 'Papules' },
        { key: 'pustules', value: 'Pustules' },
        {
          key: 'boils',
          value: 'Boils',
          answer: {
            type: 'single_select',
            label: 'How many?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'bLess5', value: 'Less than 5' },
              { key: 'b5to10', value: '5 - 10' },
              { key: 'bMore10', value: 'More than 10' }
            ]
          }
        },
        {
          key: 'cysts',
          value: 'Cysts',
          answer: {
            type: 'single_select',
            label: 'How many?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'cLess5', value: 'Less than 5' },
              { key: 'c5to10', value: '5 - 10' },
              { key: 'cMore10', value: 'More than 10' }
            ]
          }
        },
        {
          key: 'nodules',
          value: 'Nodules',
          answer: {
            type: 'single_select',
            label: 'How many?',
            level: 'child',
            thirdWidth: true,
            options: [
              { key: 'nLess5', value: 'Less than 5' },
              { key: 'n5to10', value: '5 - 10' },
              { key: 'nMore10', value: 'More than 10' }
            ]
          }
        }
      ]
    }
  },
  {
    // 2
    label: 'Have you gotten any new pimples in the last week?',
    subLabel: '(Select one)',
    field: 'acnePimples',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'This gives an idea of the current state of your acne and the possible frequency of breakouts, which helps our doctors determine what treatment is needed.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'some',
          value: 'Some',
          answer: {
            type: 'single_select',
            halfWidth: true,
            options: [
              { key: 's1to3', value: '1-3' },
              { key: 's3to7', value: '3-7' },
              { key: 's7to10', value: '7-10' },
              { key: 'sMore10', value: '10+' }
            ]
          }
        },
        { key: 'none', value: 'None' }
      ]
    }
  },
  {
    // 3
    label: 'Where are you breaking out?',
    subLabel: '(Select at least one & all that apply)',
    field: 'acneBreaking',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'If you have breakouts in multiple areas, you may need more compound cream to cover all needed spots.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'face', value: 'Face' },
        { key: 'neck', value: 'Neck' },
        { key: 'chest', value: 'Chest' },
        { key: 'shoulders', value: 'Shoulders' },
        { key: 'back', value: 'Back' },
        { key: 'all', value: 'All the above', uncheckOthers: true }
      ]
    }
  },
  {
    // 4
    label: 'What was your sex assigned at birth?',
    subLabel: '(Select one)',
    field: 'acneSex',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Biological sex affects what treatments and prescriptions work best for your body.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    // 4-1
    label: 'Are you pregnant or breastfeeding?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'acnePregnant',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'pregnant', value: 'I’m pregnant' },
        { key: 'breastfeeding', value: 'I’m breastfeeding' },
        { key: 'conceive', value: 'I’m trying to conceive' },
        { key: 'nonePregnant', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    // 4-2
    label: 'Are you taking birth control?',
    subLabel: '(Select one)',
    field: 'acneBirthControl',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'birthYes', value: 'Yes' },
        { key: 'birthNo', value: 'No' }
      ]
    }
  },
  {
    // 4-3
    label: 'Are you taking birth control for acne?',
    subLabel: '(Select one)',
    field: 'acneBirthControlAcne',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'birthAcneYes', value: 'Yes' },
        { key: 'birthAcneNo', value: 'No' }
      ]
    }
  },
  {
    // 4-4
    label: 'Tell us more!',
    subLabel: '(Please write your answer in the space provided)',
    field: 'acneBirthControlAcneMore',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Are you still using it?',
          type: 'text',
          name: 'acneBCMoreUsing'
        },
        {
          label: 'How did your skin respond, were there any side effects?',
          type: 'text',
          name: 'acneBCMoreRespond'
        },
        {
          label: 'What strength of dosage did you use, and for how long?',
          type: 'text',
          name: 'acneBCMoreStrength'
        },
        {
          label: 'What name brand do you use? ',
          type: 'text',
          name: 'acneBCMoreBrand'
        },
        {
          label:
            'Please provide any additional details you think may be useful.',
          type: 'text',
          name: 'acneBCMoreAdditional'
        }
      ]
    }
  },
  {
    // 5
    label: 'Are you allergic to any drugs or medication?',
    subLabel: '(Select one)',
    field: 'acneAllergic',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Knowing your allergies allows us to be sure none of our treatments will cause you problems.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 5-1 Mild
    label: 'Are you allergic to any drugs or medication?',
    subLabel: '(Select all that apply)',
    field: 'acneAllergicMoreMildDrugs',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hydroquinone', value: 'Hydroquinone' },
        { key: 'corticosteroids', value: 'Corticosteroids' },
        { key: 'tretinoin', value: 'Tretinoin' },
        {
          key: 'mildDrugsOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'mildDrugsOtherDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // 5-2 Mild
    label: 'What happens when you’re exposed to that product?',
    subLabel: '(Please write your answer in the space provided)',
    field: 'acneAllergicMoreMildDrugsDesc',
    type: 'info',
    answer: {
      type: 'text',
      name: 'acneAllergicMoreMildDrugsDesc1',
      placeholder: 'Please specify'
    }
  },
  {
    // 5-1 Moderate
    label: 'Are you allergic to any drugs or medication?',
    subLabel: '(Select all that apply)',
    field: 'acneAllergicMoreModerateDrugs',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'clindamycin', value: 'Clindamycin' },
        { key: 'erythromycin', value: 'Erythromycin' },
        { key: 'tretinoin', value: 'Tretinoin' },
        { key: 'moderateDrugsMore', value: 'More than one of the above' },
        {
          key: 'moderateDrugsOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'moderateDrugsOtherDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // 5-2 Moderate
    label: 'What happens when you’re exposed to that product?',
    subLabel: '(Please write your answer in the space provided)',
    field: 'acneAllergicMoreModerateDrugsDesc',
    type: 'info',
    answer: {
      type: 'text',
      name: 'acneAllergicMoreModerateDrugsDesc1',
      placeholder: 'Please specify'
    }
  },
  {
    // 5-1 Severe
    label: 'Are you allergic to any drugs or medication?',
    subLabel: '(Select all that apply)',
    field: 'acneAllergicMoreSevereDrugs',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'minocycline', value: 'Minocycline' },
        { key: 'tretinoin', value: 'Tretinoin' },
        { key: 'clindamycin', value: 'Clindamycin' },
        { key: 'doxycyline', value: 'Doxycyline' },
        { key: 'sulfacetamide', value: 'Sulfacetamide' },
        {
          key: 'severeDrugsOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'severeDrugsOtherDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // 5-2 Severe
    label: 'What happens when you’re exposed to that product?',
    subLabel: '(Please write your answer in the space provided)',
    field: 'acneAllergicMoreSevereDrugsDesc',
    type: 'info',
    answer: {
      type: 'text',
      name: 'acneAllergicMoreSevereDrugsDesc1',
      placeholder: 'Please specify'
    }
  },
  {
    // 6
    label: 'What are your skincare goals?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'acneSkinGoal',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Knowing your goals means we can make a formula with ingredients geared to tackle those issues.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fight', value: 'Fight breakouts' },
        { key: 'clogged', value: 'Treat clogged pores' },
        { key: 'firm', value: 'Firm skin' },
        { key: 'smooth', value: 'Smooth skin' },
        { key: 'fewer', value: 'Fewer wrinkles' },
        { key: 'reduce', value: 'Reduce redness and swelling' },
        { key: 'getRid', value: 'Get rid of dark spots' },
        { key: 'all', value: 'All of above', uncheckOthers: true }
      ]
    }
  },
  {
    // 7
    label: "What's your skin type?",
    subLabel: '(Select one)',
    field: 'acneSkinType',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Knowing your skin type helps us recommend treatments best suited to it.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Very dry', value: 'Very dry' },
        { key: 'Dry', value: 'Dry' },
        { key: 'Combination', value: 'Combination' },
        { key: 'Oily', value: 'Oily' },
        { key: 'Very oily', value: 'Very oily' },
        { key: 'Average', value: 'Average' },
        { key: 'Not sure', value: 'Not sure' }
      ]
    }
  },
  {
    // 8
    label: 'How sensitive is your skin to new products?',
    subLabel: '(Select one)',
    field: 'acneSensitive',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Knowing how sensitive your skin is helps us make a cream that won’t irritate it.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Very Sensitive', value: 'Very sensitive and easily irritated' },
        { key: 'Sensitive', value: 'Sensitive and sometimes irritated' },
        { key: 'Not Sensitive', value: 'Not sensitive, I can use anything' },
        { key: 'Not Sure', value: 'I’m not sure' }
      ]
    }
  },
  {
    // 9
    label: 'Do you currently use any over-the-counter skin products?',
    subLabel: '(Select at least one & all that apply)',
    field: 'acneOver',
    tooltip: [
      {
        title: 'Why are we asking this?',
        info: 'Knowing what you currently put on your skin helps us determine what it needs, and what treatments will work best.',
        lineBreak: true
      }
    ],
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'sunscreen', value: 'Sunscreen' },
        { key: 'nightCream', value: 'Night cream' },
        { key: 'moisturizer', value: 'Moisturizer' },
        { key: 'masks', value: 'Masks' },
        { key: 'toner', value: 'Toner' },
        { key: 'lipBalm', value: 'Lip balm' },
        { key: 'chemical', value: 'Chemical exfoliator' },
        { key: 'cleanser', value: 'Cleanser' },
        { key: 'serum', value: 'Serum' },
        { key: 'makeup', value: 'Makeup' },
        { key: 'eyeCream', value: 'Eye cream' },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'acneAcknowledgement',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential in accordance with the Ontario College of Pharmacists` regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'acneAcknowledgement', value: 'I Agree' }]
    }
  }
];

let skinGoalMap = {};
questionsModels
  .find(question => question.field === 'acneSkinGoal')
  .answer.options.forEach(
    ({ key, value }) => (skinGoalMap = { ...skinGoalMap, [key]: value })
  );

export { skinGoalMap };

export default questionsModels;
